<template>
  <div id="login" class="m-5">
     <div class="mt-5">
         <div style="max-width: 474px" class="mx-auto" >
            <b-button  style="background-color:#1877F2; color:#FFF; display: flex;align-items: center; padding:0 .5rem 0 0;" class="mr-3 mb-2 flex-grow-1 flex-md-grow-0"  size="md" block @click="popup(fb_link)">
                <img src="@/assets/fblogo.png" class="m-2" style="max-height:25px;"/>
                <span style="flex-grow:1; text-align:center">Continue with Facebook</span>
            </b-button>
            
            <b-button style="background-color:#4285F4; color:#FFF; display: flex;align-items: center; padding:0 .5rem 0 0;"  class="mr-3 mb-2 flex-grow-1 flex-md-grow-0" size="md" block  @click="popup(google_link)">
                <img src="@/assets/google.png" style="max-height:42px;" class="mr-2">
                <span style="flex-grow:1; text-align:center">Continue with Google</span>
            </b-button>
            <div class="position-relative">
                <hr class="position-absolute m-0" style="width:100%; top:50%; transform:translateY(-50%);"/>
                <p class="lead my-3 text-center position-relative" style="z-index:1;"><span class="bg-white px-2 d-inline-block">OR</span></p>
            </div>
            <b-form @submit.prevent="get_otp(email)" >

                <b-form-group description="Enter an email and request for a one time code. " label="Request one time code">
                
                <b-input-group>
                    <b-input type="email" placeholder="Email" v-model="email" required/>
                    <b-input-group-append>
                        <b-button type="submit" variant="primary" :disabled="code_sending ||verifying_code ">Get Code</b-button>
                    </b-input-group-append>
                </b-input-group>
                </b-form-group>
            </b-form>
            <p class="small" v-if="code_sending">You can request for another code in 1 minute</p>
            <b-form-group label="Code Verification" description="Check your email for the code" v-if="otp_sent">

                <b-input-group>
                    <b-input type="text" placeholder="Enter Code." v-model="code"/>
                    <b-input-group-append>
                        <b-button variant="primary" @click="check_otp({email, code})" :disabled="verifying_code">Verify Code</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>

         </div>
     </div>

  </div>
</template>

<script>
export default {
  name: 'login',
  data(){
        return {
            email:'',
            code:'',
            code_sending: false,
            code_sending_timer:null,
            otp_sent: false,
            verifying_code: false,
        }
    },
    props:{
        fb_link:String,
        google_link: String,
        axios: Function
    },
    computed:{
        login_action(){
            return 'Continue';
        }
    },
    methods:{
        popup(link){
            const w = 600;
            const h = 700;
            const y = window.top.outerHeight / 2 + window.top.screenY - ( h / 2);
            const x = window.top.outerWidth / 2 + window.top.screenX - ( w / 2);
            window.open(link,"login_popup", `menubar=0,resizable=1,width=${w}, height=${h}, top=${y}, left=${x}`);
        },
        get_otp(email){
            if(this.code_sending){
                return;
            }
            this.code_sending = true;
            this.axios.post('email_otp', {email}).then(()=>{
                this.otp_sent=true;
                this.code_sending_timer = setTimeout(()=>{
                    this.code_sending = false
                    this.code_sending_timer = null;
                }, 60000);
            }).catch(()=>{
                alert("Unable to send the OTP");
                this.code_sending = false;
            });
        },
        check_otp(data){
            this.verifying_code = true;

            this.axios.post('otp_login', data).then(async rsp=>{
                if(rsp.data.valid){
                    window.location.reload();
                    return
                }
                throw 'OTP Invalid';
            }).catch(()=>{
                this.verifying_code = false;
                alert("Invalid OTP")
            });

        },
    },
    watch:{
        email(){
            this.code = '';
            this.code_sending = this.otp_sent = false;
            if(this.code_sending_timer){
                clearTimeout(this.code_sending_timer);
                this.code_sending_timer = null;
            }

      }
    }
 
}
</script>